import { render } from "./MovieInfo.vue?vue&type=template&id=d8eff018&scoped=true"
import script from "./MovieInfo.vue?vue&type=script&lang=js"
export * from "./MovieInfo.vue?vue&type=script&lang=js"

import "./MovieInfo.vue?vue&type=style&index=0&id=d8eff018&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8eff018"]])

export default __exports__